import { IVehicle } from "../../../models/Vehicle";
import useVehiclePackageData from "../../../data/useVehiclePackageData";
import { ButtonInput } from "../../shared/Inputs/ButtonInput";
import { useEffect, useState } from "react";
import LoadingWheel from "../../shared/LoadingWheel";
import PriceFormat from "../../../utils/priceFormat";
import { VehiclePackage } from "../../../models/VehiclePackageData";
import { useQueryClient } from "@tanstack/react-query";


export default function PartVehicleDetails({
  vehicle
}: {
  vehicle: IVehicle;
}) {
  const { vehiclePackageData, getVehiclePackageData } = useVehiclePackageData(vehicle.id, "PartVehicleSalvage");
  const [hasSalvage, setHasSalvage] = useState<boolean | null>(null);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (vehiclePackageData.isLoading || !vehiclePackageData.data) return;

    if(vehicle?.valuationTradePoor != null) {
      setHasSalvage(true);
      return;
    }

    if (vehiclePackageData.data.data == null){
      setHasSalvage(false);
      return;
    } 

    setHasSalvage(vehiclePackageData.data.data?.valuationDetailsFetchedAt !== null);
  }, [vehiclePackageData.isLoading, vehiclePackageData.data]);

  const handleFetchSalvageValue = () => {
    getVehiclePackageData.mutate({ vehicleId: vehicle.id, package: VehiclePackage.JustSalvage },
      {
        onSuccess: (data) => {
          queryClient.invalidateQueries(["lead"]);
          queryClient.invalidateQueries(["vehiclePackage", vehicle.id]);
        }
      }
    );
  };

  if (hasSalvage === null) return <></>;

  if (hasSalvage) {
    return (<>
      <div className="py-2 grid grid-cols-3 gap-4">
        <dt className="text-sm font-medium text-gray-500">Salvage Value</dt>
        <dd className={`text-sm col-span-2`}>
          {PriceFormat(vehicle?.valuationTradePoor)}
        </dd>
      </div>
    </>);
  }

  return (
    <>
      <div className="py-2 grid grid-cols-3 gap-4">
        <dt className="text-sm font-medium text-gray-500">Salvage Value</dt>
        <dd className={`text-sm col-span-2`}>
          <ButtonInput isSubmit={false} onClick={() => handleFetchSalvageValue()} label="fetch" classes={"!py-1"} />
        </dd>
      </div>
    </>
  )
}